import { MenuItem } from '@szhsin/react-menu';

const ICON_SIZE = {
  small: '15px',
  medium: '20px',
  large: '25px',
};

function _MenuItem({ option }) {
  return (
    <MenuItem
      key={option.title}
      onClick={() => option.onClick(option)}
      disabled={false || option.disabled}
    >
      {option.icon && (
        <i
          className={option.icon}
          style={{
            marginRight: '15px',
            fontSize: option.iconSize || ICON_SIZE.medium,
            color: !option.disabled
              ? option.color
                ? option.color
                : '#2f3a3f'
              : '#AAAAAA',
          }}
        />
      )}
      <div>
        <div>
          <span
            style={{
              color: !option.disabled
                ? option.color
                  ? option.color
                  : '#2f3a3f'
                : '#AAAAAA',
              fontSize: '15px',
            }}
          >
            {option.title}
          </span>
        </div>
        {option.subtitle && (
          <span
            style={{
              fontSize: 'small',
              color: !option.disabled ? '#92929D' : '#AAAAAA',
            }}
          >
            {option.subtitle}
          </span>
        )}
      </div>
    </MenuItem>
  );
}

export default _MenuItem;
